import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculatePatioCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) return undefined;

  const { patio, craftsmanQuality, propertyType } = improvementsForTransaction;
  const zipCode = identification.address.PostalCode;

  if (isUndefined(craftsmanQuality) || isUndefined(zipCode) || !patio || !propertyType) {
    return undefined;
  }

  const params = patio.area
    ? {
        hasFeature: ORDER_FEATURES.patio.hasFeature(improvementsForTransaction),
        propertyType,
        type: patio.type,
        quality: patio.quality ?? craftsmanQuality,
        sqft: AloftArea.fromNumber(patio.area.unitAmount, patio.area.unit),
        zipCode,
      }
    : {
        hasFeature: ORDER_FEATURES.patio.hasFeature(improvementsForTransaction),
        propertyType,
        type: patio.type,
        quality: patio.quality ?? craftsmanQuality,
        zipCode,
      };

  const calculator = getCraftsmanCost(costProps);
  return calculator.getPatioCost(params);
};

export const { selectPatioCost, selectZipOnlyPatioCost, selectPatioCosts, selectPatioCostDisplay } =
  createFeatureCostSelectors({
    calculate: calculatePatioCost,
    inputSelectors: [
      selectCostProps,
      selectImprovementsEntities,
      selectPropertyIdentificationEntities,
    ],
    names: {
      cost: 'selectPatioCost',
      zipOnly: 'selectZipOnlyPatioCost',
      costs: 'selectPatioCosts',
      display: 'selectPatioCostDisplay',
    },
  });
